import React from "react"
import UnitSkeleton from "components/Skeleton/UnitSkeleton"

const ProductionLineInfoSkeleton = () => {
   return (
      <div className="production-line-skeleton">
         <div className="production-line-skeleton-row ">
            <UnitSkeleton shape="rounded" size="medium" />
         </div>
         <UnitSkeleton shape="rounded" size="small" />
         <UnitSkeleton shape="rounded" size="small" />
      </div>
   )
}

export default ProductionLineInfoSkeleton
